import { defineComponent as _defineComponent } from 'vue'
import Treeselect from '@riophae/vue-treeselect';
import { isValidTag } from '@sh/helpers';
import { MediaManager } from '@sh/types';
import { computed, ref } from 'vue';

interface Emits {
  (e: 'on-add-tag-changed', data: string): void;
  (e: 'on-select-value', data: SelectOption<string, 'id', 'label'>): void;
  (e: 'on-deselect-value', data: SelectOption<string, 'id', 'label'>): void;
}

interface LoadOptionsParams {
  action: string;
  searchQuery: string;
  callback: (p: unknown, options: Record<string, unknown>[]) => void;
}

interface TagsProps {
  autocompleteItems: MediaManager.Tag[];
}

export interface TreeselectProps {
  closeMenu: Function;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TagInputManager.ts',
  props: {
    autocompleteItems: null
  },
  emits: ["on-add-tag-changed", "on-select-value", "on-deselect-value"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-add-tag-changed', data: string): void;
  (e: 'on-select-value', data: SelectOption<string, 'id', 'label'>): void;
  (e: 'on-deselect-value', data: SelectOption<string, 'id', 'label'>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  autocompleteItems: MediaManager.Tag[];
};




const MAX_TEXT_LENGTH = 15;
const MIN_TEXT_LENGTH = 2;
const searchText = ref('');
const tagInsertRef = ref<TreeselectProps>();

const defaultTagsOptions = computed((): SelectOption<string, 'id', 'label'>[] => {
  return (props.autocompleteItems ?? []).map(({ text }) => ({ id: text, label: text }));
});

const noResultsText = computed(() => {
  if (searchText.value.length < MAX_TEXT_LENGTH && !isValidTag(searchText.value) && searchText.value !== '') {
    return 'Invalid Input: Only letters (a-z) and numbers (0-9) are allowed.';
  }
  if (searchText.value.length <= MIN_TEXT_LENGTH && searchText.value !== '') {
    return 'Tags should contain at least 3 characters!';
  }
  return 'No recent tags.';
});

const hasRecentlyUsedTags = computed(() => {
  return (
    props.autocompleteItems.filter((tag) => tag.text.toLowerCase().includes(searchText.value.toLowerCase().trim()))
      .length > 0
  );
});

function loadOptions({ action, searchQuery, callback }: LoadOptionsParams) {
  const field = searchQuery.substring(0, MAX_TEXT_LENGTH);
  if (action !== 'ASYNC_SEARCH') return;
  const filteredTags = props.autocompleteItems.filter((tag) =>
    tag.text.trim().toLowerCase().includes(field.trim().toLowerCase())
  );
  if (filteredTags && isValidTag(field) && field.length > MIN_TEXT_LENGTH) {
    const options = [
      { id: field, label: field },
      ...filteredTags.filter(({ text }) => text !== field).map(({ text }) => ({ id: text, label: text })),
    ];
    callback(null, options);
    return;
  }
  if (filteredTags && isValidTag(field) && field.length <= MIN_TEXT_LENGTH) {
    const options = [
      ...filteredTags.filter(({ text }) => text !== field).map(({ text }) => ({ id: text, label: text })),
    ];
    callback(null, options);
    return;
  }
  callback(null, []);
}

function addNewTagOnEnter() {
  if (!searchText.value) return;
  const existingOption = defaultTagsOptions.value.find((option) => option.label === searchText.value);

  if (!existingOption && isValidTag(searchText.value) && searchText.value.length > MIN_TEXT_LENGTH) {
    const newOption = {
      id: searchText.value,
      label: searchText.value,
    };
    defaultTagsOptions.value.push(newOption);
    emit('on-add-tag-changed', searchText.value);

    // Close the dropdown menu
    tagInsertRef.value?.closeMenu(true);

    // Clear the search text
    searchText.value = '';
  }
}

function onInput(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.value.length >= MAX_TEXT_LENGTH || isValidTag(input.value)) {
    input.value = input.value.substring(0, MAX_TEXT_LENGTH);
    searchText.value = input.value.substring(0, MAX_TEXT_LENGTH);
  } else {
    searchText.value = input.value;
  }
}

return { __sfc: true,props, emit, MAX_TEXT_LENGTH, MIN_TEXT_LENGTH, searchText, tagInsertRef, defaultTagsOptions, noResultsText, hasRecentlyUsedTags, loadOptions, addNewTagOnEnter, onInput, Treeselect, isValidTag }
}

})